import React from 'react';

import EntityGrid from 'components/EntityElement/EntityGrid';
import { ALGOLIA, EXTERNAL_LINKS } from 'config/constants';
import TableWithSearch from 'components/Lists/TableWithSearch';
import NoDataDisplay from 'components/NoDataDisplay';
import Button from 'components/Button';

const RELEASE_GRID_PROPS = {
  type: EntityGrid.TYPES.RELEASE,
  size: EntityGrid.SIZES.LARGE
};

interface LabelReleasesProps {
  labelId: string;
  canEditLabel: boolean;
}

const LabelReleases = ({ labelId, canEditLabel }: LabelReleasesProps) => (
  <TableWithSearch
    index={ALGOLIA.RELEASE_INDEX}
    limit={50}
    facetFilters={[[`label.id:${labelId}`]]}
    placeholderText="Search Releases"
    // NOTE: rather than render a loading, we pass loading prop to entity grid to display loading elements
    renderList={({ data, ...rest }) => (
      <EntityGrid data={data} {...RELEASE_GRID_PROPS} {...rest} />
    )}
    renderLoading={() => <div className="mb-5" />}
    renderEmpty={() => (
      <NoDataDisplay
        text={
          canEditLabel
            ? 'No music on pre-order or promo yet!'
            : 'This label does not have any releases through Proton yet.'
        }
      >
        {canEditLabel && (
          <Button to={EXTERNAL_LINKS.SOUNDSYSTEM.LABELS} newTab rounded>
            Go to SoundSystem
          </Button>
        )}
      </NoDataDisplay>
    )}
  />
);

export default LabelReleases;
